import { AbPostHog } from 'app/abstract/services/posthog.abstract';
import { IdentificacaoPostHogService } from './identificacao-posthog.service';

export function inicializarPostHog(
  servico: AbPostHog,
  identificacao: IdentificacaoPostHogService
): () => Promise<void> {
  return async () => {
    await servico.init();
    identificacao.identificarDoStorage();
  };
}
